<template>
  <div>
    <form @submit.prevent="chooseFamily">
      <select name="family" v-model="family">
        <option value="0" disabled>Choisir la famille</option>
        <option value="1">Apiacées</option>
        <option value="2">Astéracées</option>
        <option value="3">Fabacées</option>
        <option value="4">Lamiacées</option>
        <option value="5">Rosacées</option>
        <option value="6">Solanacées</option>
        <option value="7">Sapindacées</option>
        <option value="8">Renonculacées</option>
        <option value="9">Caryophyllacées</option>
        <option value="10">Verbénacées</option>
        <option value="11">Malvacées</option>
        <option value="12">Brassicacées</option>
        <option value="13">Aristolochiacées</option>
        <option value="14">Asparagacées</option>
        <option value="15">Ptéridophytes</option>
        <option value="16">Bétulacées</option>
        <option value="17">Borraginacées</option>
        <option value="18">Poacées</option>
        <option value="19">Cucurbitacées</option>
        <option value="20">Éricacées</option>
        <option value="21">Cannabinacées</option>
        <option value="22">Fagacées</option>
        <option value="23">Apocynacées</option>
        <option value="24">Caprifoliacées</option>
        <option value="25">Papavéracées</option>
        <option value="26">Rubiacées</option>
        <option value="27">Colchiacées</option>
        <option value="28">Coriariacées</option>
        <option value="29">Plantaginacées</option>
        <option value="30">Célastracées</option>
        <option value="31">Euphorbiacées</option>
        <option value="32">Polygonacées</option>
        <option value="33">Moracées</option>
        <option value="34">Rhamnacées</option>
        <option value="35">Oléacées</option>
        <option value="36">Géraniacées</option>
        <option value="37">Gymnospermes</option>
        <option value="38">Araliacées</option>
        <option value="39">Hypéricacées</option>
        <option value="40">Lauracées</option>
        <option value="41">Urticacées</option>
        <option value="42">Phytolaccacées</option>
        <option value="43">Platanacées</option>
        <option value="44">Salicacées</option>
        <option value="45">Rutacées</option>
        <option value="46">Adoxacées</option>
        <option value="47">Smilacées</option>
        <option value="48">Dioscoracées</option>
        <option value="49">Scrofulariacées</option>
        <option value="50">Vitacées</option>
        <option value="51">Toutes les familles</option>
      </select>

      <button type="submit" class="bouton3">Sélectioner</button>
    </form>
  </div>
</template>

<script>
export default {
  name: "chooseFamily",
  data() {
    return {
      family: 0,
    };
  },
  methods: {
    chooseFamily() {
      if (Number(this.family) === 0) return;
      this.$store.commit("chooseFamily", Number(this.family));
      this.$store.commit("activePage", "game");
    },
  },
};
</script>
